import { DictionaryModel, DictionarySet } from "@core/models/dictionary.model";
import { OrderDto } from "@core/models/planner-models/planner.model";

export interface OrderModel extends OrderDto {
  StartTaskType: DictionaryModel;
  EndTaskType: DictionaryModel;
  DeliveryClientNameNormalized: string;
  DeliveryContractorNameNormalized: string;
  OrderNumberNormalized: string;
  EndAddressNormalized: string;
  StartAddressNormalized: string;
  StatusDictionary?: DictionaryModel; 
}

export function mapOrderResponseToUIResponse(orders: OrderDto[], taskTypesDictionary: DictionarySet, orderStatusSet: DictionarySet): OrderModel[] {
  return orders.map(order => {
    let orderShipment: OrderModel = {
      ...order,

      EndTaskType: taskTypesDictionary[order.EndTaskTypeId],
      StartTaskType: taskTypesDictionary[order.StartTaskTypeId],
      DeliveryClientNameNormalized: order.DeliveryClientName ? order.DeliveryClientName.toLowerCase() : '',
      DeliveryContractorNameNormalized: order.DeliveryContractorName ? order.DeliveryContractorName.toLowerCase() : '',
      OrderNumberNormalized: order.OrderNumber ? order.OrderNumber.toLowerCase() : '',
      StartAddressNormalized: order.StartAddress ? order.StartAddress.toLowerCase() : '',
      EndAddressNormalized: order.EndAddress ? order.EndAddress.toLowerCase() : '',
      StatusDictionary: orderStatusSet[order.Status]
    };


    orderShipment = normalizeOrderDates(orderShipment);
    return orderShipment;
  })
}

export function normalizeOrderDates(order: OrderModel): OrderModel {
  return {
    ...order,
    StartDate: order.StartDate ? new Date(order.StartDate) : order.StartDate,
    EndDate: order.EndDate ? new Date(order.EndDate) : order.EndDate,
  }
}
